import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { type TQuoteApiCredTypes, tQuoteApi } from '../standards.js'

export type numkCredType = TQuoteApiCredTypes
export const numkDocumentTypes = [
  'delivery-photo',
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const numk: CarrierDef<numkCredType> = {
  name: 'Numark Transportation',
  scac: 'numk',
  ...tQuoteApi,
  engineLayers: ['rating', 'pickup', 'documents', 'tracking'],
  documentTypes: numkDocumentTypes,
}
